import {Component, OnInit} from '@angular/core';
import {ContestService} from '../../service/contest.service';
import {TenantService} from '../../service/tenant.service';
import {ActivatedRoute} from '@angular/router';
import {Role} from '../../model/auth/Role';
import {NotificationHandler} from '../../helper/notification.handler';
import {EventType, TrackingService} from '../../service/tracking.service';
import {PaymentStatus} from '../../model/Payment';

@Component({
  selector: 'app-contest-payment-redirect',
  templateUrl: './contest-payment-redirect.component.html',
  styleUrls: ['./contest-payment-redirect.component.scss']
})
export class ContestPaymentRedirectComponent {

  readonly contestId: string;
  readonly userId?: string;
  readonly role?: Role;
  readonly groupId?: string;

  constructor(private contestService: ContestService,
              private tenantService: TenantService,
              private trackingService: TrackingService,
              route: ActivatedRoute) {
    const params = route.snapshot.paramMap;

    this.contestId = params.get('contestId') as string;
    this.userId = params.get('userId') as string;
    this.groupId = params.get('groupId') as string;
    this.role = params.get('role') as Role;
  }

}
